export default __webpack_public_path__ + "f7b5a5cf88b55d71c54a1ce5b6b6aba4.svg";